import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import deployReservationCheck from '../../mixins/_deploy_reservation_check';
import imageSelecter from '../../components/_image_selecter';
import modalReserveDeployConfirm from '../../components/deploy/_modal_reserve_deploy_confirm';
import itemSortArrow from './_item_sort_arrow_component';

/**
 * 商品一覧コンポーネント
 */
export default {
    name: 'itemList',
    template: '#item_list_component_template',
    data () {
        return {
            // 更新、削除対象item
            selected_item: null,
            // 更新、削除操作index
            selected_index: null,
        };
    },
    props: {
        // 商品リスト
        items: {
            type: Array,
            default: () => ([]),
            require: true,
        },
        type: {
            type: String,
            required: true,
            validator: function (value) {
                return ['public', 'draft'].indexOf(value) !== -1;
            }
        },
        is_my_item_list: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        // 画像の選択、UPロードを操作するコンポーネント
        'image-selecter': imageSelecter,
        // 反映予約確認モーダルコンポーネント
        'modal-reserve-deploy-confirm': modalReserveDeployConfirm,
        // 商品のソート矢印
        'item-sort-arrow': itemSortArrow,
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        deployReservationCheck,
    ],
    computed: {
        shop_id: function () {
            return this.config.user.shop_id;
        }
    },
    emits: [
        'update:items',
        'click-sort',
    ],
    methods: {
        // idを取得
        getId: function (item) {
            return (this.isDraft()) ? item.edit_id : item.item_code;
        },
        // 下書きデータか否か(edit_idがある場合は下書き)
        isDraft: function () {
            return (this.type === 'draft');
        },
        // 編集画面へ
        edit: function (item) {
            // 下書き
            if (this.isDraft()) {
                window.location.href = '/item/new?id=' + item.edit_id;
            // 公開中商品
            } else {
                window.location.href = '/item/edit?item_code=' + item.item_code;
            }
        },
        // コピー
        copy: function (item) {
            // 下書き
            if (this.isDraft()) {
                window.location.href = '/item/new?copy=draft&id=' + item.edit_id;
            // 公開中商品
            } else {
                window.location.href = '/item/new?copy=released&id=' + item.item_code;
            }
        },
        // 削除
        remove: async function (shouldPublish = true) {

            const id = this.getId(this.selected_item);
            const type = (this.isDraft()) ? 'draft' : 'released';
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await yahooAxios.post('/item/remove', {
                    id: id,
                    type: type,
                    should_publish: shouldPublish,
                });
                if (response.data.status == 'OK') {
                    // リストを更新
                    this.emitUpdateItems(this.selected_index);
                    this.appendFlashMessage({
                        level: 'alert-info',
                        message: '削除しました',
                        autoClear: true
                    }, this.$parent);
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 削除前処理
        bereforRemove: async function (item, index) {

            const confirmMessage = (this.isDraft()) ? '下書き' : '公開中商品';
            if (!await swalConfirm(confirmMessage + 'を削除します。よろしいですか？')) {
                return;
            }

            // 削除対象item, indexを保持
            this.selected_item = item;
            this.selected_index = index;

            try {
                // 反映予約有無をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    this.$refs.modalReserveDeployConfirmForRemore.open();
                    return;
                }
                // 予約なし
                this.remove(true);

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
            }
        },
        // 公開/非公開切り替え処理
        togglePublicStatus: async function(should_deploy) {

            this.$_loading();
            var message = '';
            try {
                const response = await axios.put('/item/update_public_status', {
                    item_code: this.selected_item.item_code,
                    display: this.selected_item.display,
                    should_deploy: should_deploy,
                });

                if (response.data.status == 'OK') {
                    // 更新完了メッセージを表示
                    this.appendFlashMessage({
                        level: 'alert-info',
                        message: '更新しました。反映までは数分のタイムラグがあります',
                        autoClear: true
                    }, this.$parent);
                    message = '';
                } else {
                    message = response.data.message;
                }

            } catch (e) {
                message = this.getCatchMessage(e);
            } finally {
                if(message) {
                    // エラーが発生した場合の処理
                    // メッセージを表示
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                    // 公開フラグを戻す
                    this.initPublishStatus();
                }
                this.$_unloading();
            }
        },
        // 公開/非公開切り替え前処理
        beforeTogglePublicStatus: async function(item) {

            this.selected_item = item;
            try {
                // 反映予約有無をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    this.$refs.modalReserveDeployConfirm.open();
                    return;
                }
                // 予約なし
                this.togglePublicStatus(true);

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
                this.initPublishStatus();
            }
        },
        // 公開フラグを初期化する
        initPublishStatus: function() {
            this.selected_item.display = this.selected_item.display === '0' ? '1' : '0';
        },
        // 画像パスにタイムスタンプを付与してキャッシュ対策
        getPreviewImagePath: function (image) {
            return image + '?' + Date.now();
        },
        // ソート矢印の向きの初期化処理
        initSortArrow: function () {
            this.$refs.item_name_sort_arrow.initSortArrow();
            this.$refs.item_code_sort_arrow.initSortArrow();
        },
        // -------------------------
        // emit
        // -------------------------

        // リストを更新して親へ通知
        emitUpdateItems: function (index) {
            let items = _.cloneDeep(this.items);
            items.splice(index, 1);
            this.$emit('update:items', items);
        },

        // ソートのクリックを親に通知
        emitClickSort: function (sort) {
            this.$emit('click-sort', sort);
        }
    }
};
